import { Interface } from 'ethers'
import { PublicClient } from 'viem'

import { ContractWriteParams, GasFeeMetrics, GasFeeSimulationResults } from '@src/types/gasFees'

function getInterface(signature: string) {
    const hrAbi = [`function ${signature}`]
    return new Interface(hrAbi)
}

export async function simulateEVMGasFees(
    transactions: ContractWriteParams[],
    gasFeeMetrics: GasFeeMetrics,
    publicClient: PublicClient
): Promise<GasFeeSimulationResults> {
    const toRaw = (param: any): any => {
        if (Array.isArray(param)) {
            return param.map(toRaw)
        }
        if (param && typeof param === 'object' && 'value' in param) {
            return param.value
        }
        return param
    }

    let totalGasUnits = BigInt(0)
    const individualGasUnits: bigint[] = []

    // Process each transaction
    for (const tx of transactions) {
        const iface = getInterface(tx.functionSignature)
        const rawParams = toRaw(tx.functionParams)
        const encodedData = iface.encodeFunctionData(tx.functionSignature.split('(')[0], rawParams)

        const gasEstimate = await publicClient.estimateGas({
            data: encodedData as `0x${string}`,
            account: tx.caller as `0x${string}`,
            to: tx.contractAddress as `0x${string}`,
            value: tx.value ?? BigInt(0),
        })

        individualGasUnits.push(BigInt(gasEstimate))
        totalGasUnits += BigInt(gasEstimate)
    }

    const totalFeePerGasUnit =
        gasFeeMetrics.isEIP1559 && gasFeeMetrics.EIP1559Params
            ? (gasFeeMetrics.EIP1559Params.maxFee * BigInt(90000)) / BigInt(100000)
            : gasFeeMetrics.currentGasPrice

    return {
        totalGasUnits,
        indivdualGasUnits: individualGasUnits,
        totalFeePerGasUnit,
        feeMetrics: gasFeeMetrics,
    }
}
